module.exports = __webpack_public_path__ + "img/m_techobg.c78ebef4.jpg";